import { usersCount } from '@/apis/revenue/meterManage'
export default {
  data() {
    return {}
  },
  mounted() {},
  methods: {
    getAllData() {
      usersCount().then(res => {
        let arumUsersCount = res.data.arumUsersCount
        let brumUsersCount = res.data.brumUsersCount
        let metersCount = res.data.metersCount
        this.getUsersCountview(arumUsersCount, 'civilUser')
        this.getUsersCountview(brumUsersCount, 'uncivilUser')
        this.getUsersCountview(metersCount, 'meterUser')
        console.log(res)
      })
    },
    // 底部三个统计
    getUsersCountview(data, operName) {
      let seriesData = []
      data.forEach(item => {
        seriesData.push({ name: item.userTypeName, value: item.counts })
      })
      let optionColorArr = {
        居民: '#33BD98',
        气代煤: '#3978F3',
        工商业: '#3978F3',
        公福业: '#F7951F',
        IC卡表: '#F7951F',
        物联网表: '#33BD98',
        普表: '#3978F3'
      }
      let option = {
        color: seriesData.map(item => optionColorArr[item.name]),
        tooltip: {
          trigger: 'item',
          show: true
        },
        grid: {
          top: '0',
          left: '0',
          right: '0',
          bottom: '0',
          containLabel: true
        },
        legend: {
          type: 'scroll',
          orient: 'vertical',
          left: '55%',
          align: 'left',
          top: 'middle',
          itemGap: 20,
          itemWidth: 10,
          itemHeight: 10,
          icon: 'circle',
          formatter: params => {
            let data = seriesData.find(el => el.name == params)
            return `{a| ${data.name}}{b0| ${data.value}}`
          },
          textStyle: {
            rich: {
              a: {
                color: '#8D8D8D',
                fontSize: 14,
                width: 60
              },
              b0: {
                // color: colorList[0],
                color: '#333',
                fontSize: 14,
                fontWeight: 800,
                padding: [0, 0, 0, 10]
              }
            }
          }
        },
        series: [
          {
            type: 'pie',
            center: ['25%', '50%'],
            radius: ['55%', '80%'],
            clockwise: true, //饼图的扇区是否是顺时针排布
            avoidLabelOverlap: false,
            label: {
              show: false
            },
            labelLine: {
              // 设置标签指示线
              show: false // 是否显示指示线
            },
            itemStyle: {
              borderWidth: 2, // 设置边框宽度
              borderColor: '#ffffff' // 设置边框颜色，与背景色相同即可形成间距效果
            },
            data: seriesData
          }
        ]
      }
      this[operName].setOption(option, true)
    },
    // 上层折线统计图
    getFeeStatisview(data) {
      let paidInArr = []
      let receivableArr = []
      let xArr = []
      data.forEach(item => {
        xArr.push(item.beginTime)
        paidInArr.push(item.paidIn)
        receivableArr.push(item.receivable)
      })
      let option = {
        tooltip: {
          trigger: 'axis'
        },
        grid: {
          top: '80',
          left: '0',
          right: '40',
          bottom: '40',
          containLabel: true
        },
        legend: {
          left: 'center',
          top: '24',
          itemHeight: 1,
          itemWidth: 24,
          textStyle: {
            fontSize: 14,
            color: '#686C87'
          },
          data: ['应收', '实收']
        },
        xAxis: {
          type: 'category',
          data: xArr
        },
        yAxis: {
          type: 'value'
        },
        series: [
          {
            data: receivableArr,
            type: 'line',
            name: '应收'
          },
          {
            data: paidInArr,
            type: 'line',
            name: '实收'
          }
        ]
      }
      this.feeStatis.setOption(option, true)
    }
  }
}
